import bart from './images/bart.png';
import chiefWiggam from './images/chief-wiggam.gif';
import homerSimpson from './images/homer.jpg';
import krustyTheClown from './images/krusty.jpg';
import maggie from './images/maggie.jpg';
import milhouse from './images/milhouse.png';
import mrBurns from './images/mr-burns.png';
import nedFlanders from './images/ned-flanders.jpg';
import marge from './images/marge.jpg';
import ralph from './images/ralph.jpg';
import santasLilHelper from './images/santas-lil-helper.jpg';
import sideshowBob from './images/sideshow-bob.png';

const images = [
    bart, 
    chiefWiggam, 
    homerSimpson, 
    krustyTheClown, 
    maggie,  
    milhouse,  
    mrBurns,  
    nedFlanders,  
    marge,  
    ralph,  
    santasLilHelper,  
    sideshowBob  
]

export default images;

